import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Constants } from '../../shared/Constants';

@Injectable()
export class HsMenuService {

  constructor(public http: HttpClient) { }

  getMenu() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/HS_Menu/', { headers: headers });
  }
}



// WEBPACK FOOTER //
// ./src/app/system/services/hs-menu.service.ts